$(document).ready(function() {
    $('[data-aos]').addClass('aos-init');

    if ($('.inner-banner').length) {
        $('.inner-banner .aos-init').addClass('aos-animate');
    }

    if ($('.contact').length) {
        $('.contact .aos-init').addClass('aos-animate');
    }

    if ($('.articles .paginate').length) {
        if ($('.paginate').find('.page:not(.disable)').length > 0)
            $('.paginate').css('display', 'flex');
        else
            $('.paginate').css('display', 'none');
    
        $(document).on('click', '.paginate a', function(e) {
            e.preventDefault();
    
            let newUrl = $(this).attr('href');

            $.ajax({
                type: "GET",
                url: newUrl,
                success: function(data) {

                    if ($(data).find('.paginate-items').find('.article').length > 0) {
                        $('.paginate-items').html($(data).find('.paginate-items').html());
                    }

                    let newPage = $(data).find('.paginate').html();
                    $('.paginate').html(newPage);

                    $('html, body').animate({
                        scrollTop: $('.paginate-items').offset().top - 150
                    }, 0);
                },
                error: function() {
                    console.log("Error occurred while paginating.");
                },
            });
        
            if (window.history && window.history.pushState) {
                window.history.pushState(null, null, newUrl);
            }
    
        });
    }
});

$(document).on('click', '.articles .article', function() {
    let url = $(this).find('a').attr('href');
    window.location.href = url;
});